import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center text-danger-500 py-6"
}
const _hoisted_3 = {
  key: 2,
  class: "text-center py-6"
}
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { class: "lg:grid lg:grid-cols-3 gap-[25px]" }
const _hoisted_6 = { class: "lg:col-span-2" }
const _hoisted_7 = { class: "lg:col-span-1" }
const _hoisted_8 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[25px] mb-[25px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrackingID = _resolveComponent("TrackingID")!
  const _component_RecentOrders = _resolveComponent("RecentOrders")!
  const _component_OrderSummary = _resolveComponent("OrderSummary")!
  const _component_BillingDetails = _resolveComponent("BillingDetails")!
  const _component_ShippingDetails = _resolveComponent("ShippingDetails")!
  const _component_DeliveryDetails = _resolveComponent("DeliveryDetails")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500" }, null, -1)
      ])))
    : (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : (!_ctx.order)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.directT('ecommerce.orderDetails.orderNotFound')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_TrackingID, { order: _ctx.order }, null, 8, ["order"]),
                _createVNode(_component_RecentOrders, {
                  orderId: _ctx.orderId,
                  order: _ctx.order
                }, null, 8, ["orderId", "order"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_OrderSummary, { order: _ctx.order }, null, 8, ["order"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_BillingDetails, { order: _ctx.order }, null, 8, ["order"]),
              _createVNode(_component_ShippingDetails, { order: _ctx.order }, null, 8, ["order"]),
              _createVNode(_component_DeliveryDetails, { order: _ctx.order }, null, 8, ["order"])
            ])
          ]))
}